<div class="{{ pricesClasses$$()?.marginPrice }}">
    <!-- Moneda habitual -->
    @if (pricesStyles$$() || primaryCurrencyClasses$$()) {
        <div [classList]="primaryCurrencyClasses$$() ?? ''" [ngStyle]="pricesStyles$$()" [attr.aria-label]="price$$()?.primaryCurrency">
            {{ price$$()?.primaryCurrency }}
        </div>
    } @else {
        {{ price$$()?.primaryCurrency }}
    }

    <!-- Moneda alternativa -->
    @if (showAlternativeCurrency$$()) {
        <div>
            @for (priceFormatted of pricesFormatted$$()?.secondaryCurrencies; track $index; let i = $index) {
                <!-- Precio secundario -->
                @if (secundaryCurrency$$() && secondaryPricesFormatted$$()) {
                    <div [attr.aria-label]="secondaryPricesFormatted$$()?.secondaryCurrencies[i]">
                        ({{ secondaryPricesFormatted$$()?.secondaryCurrencies[i] }})
                    </div>
                }

                <!-- Precio primario -->
                @if (primaryCurrency$$()) {
                    <div [attr.aria-label]="priceFormatted">({{ priceFormatted }})</div>
                }
            }
        </div>
    }
</div>
